module.exports = "//static.hsappstatic.net/lead-flows-ui/static-1.9346/img/dynos/top.png"